import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Map } from "immutable";
import { FormSection, Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import AdditionalDetails, {
  validate
} from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection";
import { ShippingSection } from "MODULES/shared/components/ShippingSection";
import * as actions from "MODULES/SalesOrders/actions";
import FinalDestinationFields from "MODULES/shared/components/FinalDestination/FinalDestinationFields";
import { transformSO } from "MODULES/SalesOrders/helpers";
import {
  CANCELLED,
  COMPANY,
  LINE_ITEMS,
  SHIP_TO,
  SHIPPED
} from "APP_ROOT/constants";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { withRouter } from "react-router";
import { loadRecord } from "MODULES/shared/decorators";
import DoNotDoBusinessShippingWarning from "MODULES/SalesOrders/components/shared/Warnings/DoNotDoBusinessShippingWarning";

const FORM_NAME = "salesOrderShipToDetails";

export function Form(props) {
  const { salesOrderWithAllLineItems } = props;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormSection name="">
          <h4>Ship To</h4>
          <DoNotDoBusinessShippingWarning />
          <ShippingSection
            shippingType={SHIP_TO}
            shipToCustomer={salesOrderWithAllLineItems
              .get(COMPANY, Map())
              .toJS()}
            shipToCompany={salesOrderWithAllLineItems.get("ship_to_company")}
            beforeShippingMethod={
              <FinalDestinationFields
                change={props.change}
                formName={FORM_NAME}
              />
            }
            convertSO={false}
            wtDimsReq
          >
            <hr className="hr-sm hr-dashed margin-top-none" />
            <Row>
              <Col xs={6}>
                <Field
                  name={`ship_to_fob`}
                  component={FormInput}
                  label={"Ship To FOB"}
                  required
                />
              </Col>
            </Row>
            <AdditionalDetails
              disablePicturesRequired={salesOrderWithAllLineItems
                .get(LINE_ITEMS)
                .filter(l => !l.get(CANCELLED))
                .every(l => l.get(SHIPPED))}
            />
          </ShippingSection>
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  salesOrder: T.instanceOf(Map)
};

export default withCurrentUser(
  withRouter(
    connect(
      state => ({
        salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get(
          "salesOrderWithAllLineItems"
        )
      }),
      {
        onSubmit: data => actions.update(transformSO(data))
      }
    )(
      loadRecord({
        reducer: "salesOrderWithAllLineItemsDetail",
        name: "salesOrderWithAllLineItems",
        action: id => actions.fetchSalesOrderWithAllLineItems(id)
      })(
        form({
          form: FORM_NAME,
          validate
        })(Form)
      )
    )
  )
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/ShipTo/Form.jsx